import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Billing from "../../../containers/modules/sales/billing";

export default function BillingRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="billing"
      index
        element={
        <AccessControl
            name={"Billing List"}
            auth={authUser}
            component={() => <Billing />}
        />
        }
    />
  );
}
